import api from "./api";

// export const ScanAPI = {
//   /**
//    * Preload / preview status
//    */
//   check(id) {
//     return api.get(`/api/scan/${id}`);
//   },

//   /**
//    * Execute scan (consume ticket)
//    */
//   execute(id) {
//     return api.post(`/api/scan/${id}`);
//   },

  
// };


export const ScanAPI = {
  check(bookingId) {
    return api.get(`/api/scan/ticket/${bookingId}`);
  },
  execute(bookingId, body) {
    return api.post(`/api/scan/ticket/${bookingId}`, body);
  },
  /**
   * Public ticket lookup by ticket code (no auth required)
   */
  getPublicTicket(code) {
    return api.get(`/api/scan/tickets/${code}/public`);
  },
};